<template>
  <vx-tooltip :text="$t('blind_transfer')" position="bottom">
    <vs-button
      class="includeIcon includeIconOnly"
      color="success"
      type="border"
      @click="process">
      <i class="c-icon-blind-transfer"></i>
    </vs-button>
  </vx-tooltip>
</template>

<script>
import Cti from '@/models/Cti'

export default {
  name: 'CtiBlindTransfer',
  props: {
    server: {
      required: true
    },
    isDisplay: {
      default: false
    }
  },
  computed: {
    phoneNumber () {
      return this.$store.getters.phoneNumber
    },
    sipChannel () {
      return this.$store.getters.sipChannel
    }
  },
  methods: {
    process () {
      if (this.isDisplay) {
        return
      }

      if (this.phoneNumber === null || this.phoneNumber.toString().length <= 0) {
        this.$vs.notify({
          title:'CTI Notice',
          text:'Phone Number is Required.',
          color:'danger',
          position:'top-right'
        })
        return
      }

      if (this.sipChannel === null || this.sipChannel.toString().length <= 0) {
        this.$vs.notify({
          title:'CTI Notice',
          text:'Ongoing Call is Needed.',
          color:'danger',
          position:'top-right'
        })
        return
      }

      const data = {
        fromchannel: this.sipChannel,
        channel: this.phoneNumber
      }

      try {
        Cti.blindTransfer(this.server.domain, data)
        this.$vs.notify({
          title:'CTI Notice',
          text:`${this.phoneNumber} 으로 돌려 주기 완료`,
          color:'success',
          position:'top-right'
        })
      } catch (e) {
        this.$vs.notify({
          title:'CTI Notice',
          text:'Blind Transfer Error',
          color:'danger',
          position:'top-right'
        })
      }
    }
  }
}
</script>

<style scoped>

</style>
